import {
	Component,
	Input,
	OnInit,
	VERSION,
	ViewChild,
	ViewEncapsulation,
	AfterViewInit,
	ViewChildren,
	QueryList,
} from '@angular/core';
import { EventEmitter, Output, ElementRef, Renderer2 } from '@angular/core';
import NotificationParam = Rest_task.NotificationParam;
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
import { Subscription } from 'rxjs';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { Rest_logistics } from 'app/modules/task/Logistics/services/rest_client_logistics';

@Component({
	selector: 'app-cercalia-autocomplete',
	templateUrl: './cercalia-autocomplete.component.html',
	styleUrls: ['./cercalia-autocomplete.component.css'],
	providers: [TranslateService],
	encapsulation: ViewEncapsulation.None,
})
export class CercaliaAutocompleteComponent implements OnInit, AfterViewInit {
	private subscription: Subscription;
	@ViewChild('cercaliaAutocompleteId') element: ElementRef;

	private cercaliaInitialized = false;
	cercalia: any;
	autocompleteCercalia: any;
	tooltipMessage1 = this.translate.instant('administration.customers.notGeocoded');
	tooltipMessage2 = this.translate.instant('administration.customers.geocodedOK');
	tooltipMessage3 = this.translate.instant('administration.customers.selectAddressSuggestions');
	addressEditing: boolean = false;
	autoCompleteId: string;
	localizationStr: string = '';
	//@Input() locationData: any;

	@Input() canDelete: boolean = true;

	@Input() localization: Rest_logistics.Localization;

	@Output() public newLocation = new EventEmitter();

	ngAfterViewInit(): void {
		this.initCercaliaSubscirption();
	}
	ngOnInit() {}

	constructor(protected notificationsService: NotificationsService, protected translate: TranslateService) {
		this.autoCompleteId = this.generateRandomString();
	}
	public initCercaliaSubscirption() {
		setTimeout(() => {
			if (this.element) {
				this.setCercaliaInAngular();
				this.localizationStr = this.getCercaliaLocalizationValue();
			}
			//this.elements forEach((elm) => this.setCercaliaInAngular());
			//  this.setCercaliaInAngular()
		}, 500);
	}

	getCercaliaLocalizationValue() {
		let address = '';
		if (this.localization != null) {
			address = `${this.localization?.address1}${this.localization?.city ? ', ' + this.localization?.city : ''}${
				this.localization?.postalCode ? ', ' + this.localization?.postalCode : ''
			}${this.localization?.municipality ? ', ' + this.localization?.municipality : ''}`;
		}

		return address;
	}

	setCercaliaInAngular() {
		this.cercalia = (<any>window).cercalia;
		var reverseGeocoding = new this.cercalia.service.ReverseGeocoding();
		let that = this;

		this.autocompleteCercalia = new this.cercalia.service.Autocomplete({
			autocompleteId: this.autoCompleteId,
			searchInsideCountry: 'ESP',
			callbackFunction: function (data) {
				if (data instanceof that.cercalia.LonLat) {
					reverseGeocoding.getDirection(data, function (jsonResponse) {
						that.handeCercaliaResponse(jsonResponse);
					});
				} else {
					that.handeCercaliaResponse(data);
				}
			},
		});
		//this.setAutocompleteOnChange();
	}

	handeCercaliaResponse(jsonResponse) {
		let nameFormatted = jsonResponse.formatted_address?.split(',')[0];
		let nameWithoutComas = jsonResponse.name?.value.replace(/,/g, '');

		if (
			jsonResponse.name?.value &&
			nameWithoutComas == nameFormatted &&
			jsonResponse.coord?.x &&
			jsonResponse.coord?.y
		) {
			this.localization = {} as Rest_logistics.Localization;
			this.localization.id = 0;
			this.localization.name = jsonResponse.name?.value || '';
			this.localization.address1 = jsonResponse.name?.value || '';
			this.localization.address2 = jsonResponse.district?.value || '';
			this.localization.city = jsonResponse.city?.value || '';
			this.localization.municipality = jsonResponse.country?.value || '';
			this.localization.province = jsonResponse.region?.value || '';
			this.localization.postalCode = jsonResponse.postalcode?.id || '';
			this.localization.latitude = jsonResponse.coord?.y || 0;
			this.localization.longitude = jsonResponse.coord?.x || 0;
			this.localization.geocoded = 1;
			//geocoded ok
			this.localizationStr = this.getCercaliaLocalizationValue();
			this.addressEditing = false;
			this.newLocation.emit(this.localization);
			this.notificationsService.add(
				Severity.success,
				'',
				this.translate.instant('administration.customers.geocodedOK')
			);
		} else {
			//not geocoded

			this.notificationsService.add(
				Severity.error,
				'',
				this.translate.instant('administration.customers.addressNotExists')
			);
			//this.autocompleteCercalia.setValue(this.getCercaliaLocalizationValue());
		}
	}

	onAddressEditInit() {
		this.addressEditing = true;
		this.autocompleteCercalia.setValue('');
	}
	onAddressEditCancel() {
		this.addressEditing = false;
	}
	onAddressDelete() {
		this.localizationStr = '';
		this.localization = null;
		this.newLocation.emit(this.localization);
		this.notificationsService.add(
			Severity.success,
			'',
			this.translate.instant('administration.customers.addressDeleted')
		);
	}

	/*** UTILS ***/
	generateRandomString(): string {
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
		let result = '';
		const charactersLength = characters.length;

		for (let i = 0; i < 5; i++) {
			const randomIndex = Math.floor(Math.random() * charactersLength);
			result += characters.charAt(randomIndex);
		}

		return result;
	}

	/*
		setLocalizationData() {
			if (this.localization?.address1 != null && this.localization?.address1) {
				this.localizationValue = this.getCercaliaLocalizationValue();
				this.autocompleteCercalia.setValue(this.localizationValue);
			} else {
				this.autocompleteCercalia.setValue('');
			}
		}
	
		setAutocompleteOnChange() {
		const container = document.getElementById(this.autoCompleteId);

		if (container) {
			// Buscar el input dentro de los divs hijos
			const inputElement = container.querySelector('input');

			if (inputElement) {
				// Agregar evento change al input
				inputElement.addEventListener('change', (event: Event) => {
					const value = (event.target as HTMLInputElement).value;
 					this.localization = null;
					console.log('Valor cambiado:', value);
				});
			} else {
				console.error('No se encontró el input dentro de cerrcalia-autocomplete');
			}
		} else {
			console.error('No se encontró el div con ID autocompleteContainer');
		}
	}
	getValue(): string {
		const parentElement = document.getElementById(this.autoCompleteId);
		if (!parentElement) {
			console.warn(`Elemento con ID "${this.autoCompleteId}" no encontrado.`);
			return null;
		}

		const inputElement = parentElement.querySelector('input');
		if (!inputElement) {
			console.warn(`No se encontró un input dentro del elemento con ID "${this.autoCompleteId}".`);
			return null;
		}

		return (inputElement as HTMLInputElement).value;
	}
	*/
}
